'use es6';

import { connect } from 'react-redux';
import * as FormsActions from 'ContentData/actions/Forms';
import * as formsSelectors from 'ContentData/selectors/forms';

// Needed for GDPR select.
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import FormWithInlineEditing from './FormWithInlineEditing';
const mapStateToProps = (state, props) => {
  const selectedForm = formsSelectors.getDraftForm(state, props);
  return Object.assign({}, props, {
    selectedForm,
    subscriptions: formsSelectors.getSubscriptions(state),
    consentCopy: formsSelectors.getConsentCopy(state, selectedForm),
    shouldShowPagesModal: formsSelectors.getShouldShowPagesModal(state, props)
  });
};
const mapDispatchToProps = {
  fetchDraftForm: FormsActions.fetchDraftForm,
  fetchProperties: FormsActions.fetchContactProperties,
  fetchSubscriptions: FormsActions.fetchSubscriptionDefinitions,
  fetchDefaultConsentCopy: FormsActions.fetchDefaultConsentCopy,
  saveForm: FormsActions.saveFormDraft,
  updateFormDraft: FormsActions.updateFormDraft,
  fetchParentPages: FormsActions.fetchParentPages
};
export default connect(mapStateToProps, mapDispatchToProps)(FormWithInlineEditing);